/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateDiscreteNumericListDto } from './CreateDiscreteNumericListDto';
import {
    CreateDiscreteNumericListDtoFromJSON,
    CreateDiscreteNumericListDtoFromJSONTyped,
    CreateDiscreteNumericListDtoToJSON,
} from './CreateDiscreteNumericListDto';
import type { CreateEnumerationValueDto } from './CreateEnumerationValueDto';
import {
    CreateEnumerationValueDtoFromJSON,
    CreateEnumerationValueDtoFromJSONTyped,
    CreateEnumerationValueDtoToJSON,
} from './CreateEnumerationValueDto';
import type { CreateNumericValueDto } from './CreateNumericValueDto';
import {
    CreateNumericValueDtoFromJSON,
    CreateNumericValueDtoFromJSONTyped,
    CreateNumericValueDtoToJSON,
} from './CreateNumericValueDto';

/**
 * 
 * @export
 * @interface CreateElectronBeamQualityDoseRateValueListDto
 */
export interface CreateElectronBeamQualityDoseRateValueListDto {
    /**
     * 
     * @type {string}
     * @memberof CreateElectronBeamQualityDoseRateValueListDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateElectronBeamQualityDoseRateValueListDto
     */
    beamQualityId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateElectronBeamQualityDoseRateValueListDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateElectronBeamQualityDoseRateValueListDto
     */
    name?: string | null;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreateElectronBeamQualityDoseRateValueListDto
     */
    radiationType?: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreateElectronBeamQualityDoseRateValueListDto
     */
    energy?: CreateNumericValueDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreateElectronBeamQualityDoseRateValueListDto
     */
    highDoseTechniqueType?: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateDiscreteNumericListDto}
     * @memberof CreateElectronBeamQualityDoseRateValueListDto
     */
    selectedDoseRates?: CreateDiscreteNumericListDto;
    /**
     * 
     * @type {string}
     * @memberof CreateElectronBeamQualityDoseRateValueListDto
     */
    $type?: CreateElectronBeamQualityDoseRateValueListDtoTypeEnum;
}


/**
 * @export
 */
export const CreateElectronBeamQualityDoseRateValueListDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersCreateElectronBeamQualityDoseRateValueListDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.CreateElectronBeamQualityDoseRateValueListDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateElectronBeamQualityDoseRateValueListDtoTypeEnum = typeof CreateElectronBeamQualityDoseRateValueListDtoTypeEnum[keyof typeof CreateElectronBeamQualityDoseRateValueListDtoTypeEnum];



/**
 * Check if a given object implements the CreateElectronBeamQualityDoseRateValueListDto interface.
 */
export function instanceOfCreateElectronBeamQualityDoseRateValueListDto(value?: unknown): value is CreateElectronBeamQualityDoseRateValueListDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateElectronBeamQualityDoseRateValueListDtoTypeEnum)[0];
}

export function CreateElectronBeamQualityDoseRateValueListDtoFromJSON(json: any): CreateElectronBeamQualityDoseRateValueListDto {
    return CreateElectronBeamQualityDoseRateValueListDtoFromJSONTyped(json, false);
}

export function CreateElectronBeamQualityDoseRateValueListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateElectronBeamQualityDoseRateValueListDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'beamQualityId': json['beamQualityId'] == null ? undefined : json['beamQualityId'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'name': json['name'] == null ? undefined : json['name'],
        'radiationType': json['radiationType'] == null ? undefined : CreateEnumerationValueDtoFromJSON(json['radiationType']),
        'energy': json['energy'] == null ? undefined : CreateNumericValueDtoFromJSON(json['energy']),
        'highDoseTechniqueType': json['highDoseTechniqueType'] == null ? undefined : CreateEnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        'selectedDoseRates': json['selectedDoseRates'] == null ? undefined : CreateDiscreteNumericListDtoFromJSON(json['selectedDoseRates']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateElectronBeamQualityDoseRateValueListDtoToJSON(value?: CreateElectronBeamQualityDoseRateValueListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'beamQualityId': value['beamQualityId'],
        'isEnabled': value['isEnabled'],
        'name': value['name'],
        'radiationType': CreateEnumerationValueDtoToJSON(value['radiationType']),
        'energy': CreateNumericValueDtoToJSON(value['energy']),
        'highDoseTechniqueType': CreateEnumerationValueDtoToJSON(value['highDoseTechniqueType']),
        'selectedDoseRates': CreateDiscreteNumericListDtoToJSON(value['selectedDoseRates']),
        '$type': value['$type'],
    });
}

